/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/prop-types */
import React from "react";
import { Modal, Button } from "react-bootstrap";
import "../../styles/styles.scss";
import { Translation } from 'react-i18next';


class PrivacyModal extends React.Component {
  render() {
    return (
      <Translation>{tr => (<Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="no-backdrop"
      >
        <Modal.Header closeButton closeLabel={tr("common:close")}>
          <Modal.Title id="contained-modal-title-vcenter" style={{ textAlign: "justify" }}>
            <h3 style={{ padding: "0 0 0 0px" }}>
              <strong>{tr("public:legalText77")}</strong>
            </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: 'calc(100vh - 350px)', overflowY: 'auto' }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-1" />
              <div className="col-xl-10">
                <div className="politykaPrywatnosci">
                  <h3>{tr("public:legalText78")}</h3>
                  <hr />
                  <div className="lh166">
                    <h3 className="pb-12"><strong>{tr("public:legalText79")}</strong></h3>
                    <ol>
                      <li>{tr("public:legalText80")}<b> www.extra-english.pl</b>
                      </li>
                      <li>{tr("public:legalText82")}</li>
                      <li>{tr("public:legalText83")}</li>
                      <li>{tr("public:legalText84")}</li>
                      <li>{tr("public:legalText85")}</li>
                      <ul>
                        <li>{tr("public:legalText86")}</li>
                        <li>{tr("public:legalText87")}</li>
                      </ul>
                      <li>{tr("public:legalText88")}<ol>
                          <li>{tr("public:legalText89")}</li>
                          <li>{tr("public:legalText90")}</li>
                        </ol>
                      </li>
                    </ol>
                    <h3 className="pb-12"><strong>{tr("public:legalText91")}</strong></h3>
                    <ol>
                      <li>{tr("public:legalText92")}</li>
                      <li>{tr("public:legalText93")}</li>
                    </ol>
                    <h3 className="pb-12"><strong>{tr("public:legalText94")}</strong></h3>
                    <ol>
                      <li>{tr("public:legalText95")}</li>
                    </ol>
                    <h3 className="pb-12"><strong>{tr("public:legalText96")}</strong></h3>
                    <ol>
                      <li>{tr("public:legalText97")}<ul><li>{tr("public:legalText98")}</li></ul>
                      </li>
                      <li>{tr("public:legalText99")}</li>
                      <li>{tr("public:legalText100")}<ul>
                          <li>{tr("public:legalText101")}</li>
                          <li>{tr("public:legalText102")}</li>
                          <li>{tr("public:legalText103")}</li>
                          <li>{tr("public:legalText104")}</li>
                          <li>{tr("public:legalText105")}</li>
                        </ul>
                      </li>
                      <li>{tr("public:legalText106")}</li>
                      <li>{tr("public:legalText107")}</li>
                      <li>{tr("public:legalText108")}</li>
                      <li>{tr("public:legalText109")}</li>
                      <li>{tr("public:legalText110")}</li>
                    </ol>
                    <h3 className="pb-12"><strong>{tr("public:legalText111")}</strong></h3>
                    <ol>
                      <li>{tr("public:legalText112")}</li>
                      <li>{tr("public:legalText113")}</li>
                      <li>{tr("public:legalText114")}</li>
                      <li>{tr("public:legalText115")}</li>
                    </ol>

                    <h3 className="pb-12"><strong>{tr("public:legalText116")}</strong></h3>
                    <ol>
                      <li>{tr("public:legalText117")}</li>
                    </ol>
                    <h3 className="pb-12"><strong>{tr("public:legalText118")}</strong></h3>
                    <ol><li>{tr("public:legalText119")}</li></ol>

                    <h3 className="pb-12"><strong>{tr("public:legalText120")}</strong></h3>
                    <ol>
                      <li>{tr("public:legalText121")}</li>
                      <li>{tr("public:legalText122")}</li>
                      <li>{tr("public:legalText123")}</li>
                      <li>{tr("public:legalText124")}<ol>
                          <li>{tr("public:legalText125")}</li>
                          <li>{tr("public:legalText126")}</li>
                        </ol>
                      </li>
                      <li>{tr("public:legalText127")}</li>
                      <li>{tr("public:legalText128")}</li>
                      <li>{tr("public:legalText129")}</li>
                      <li>{tr("public:legalText130")}</li>
                    </ol>
                    <h3 className="pb-12"><strong>{tr("public:legalText131")}</strong></h3>
                    <ol>
                      <li>{tr("public:legalText132")}</li>
                      <li>{tr("public:legalText133")}<ul>
                          <li><a href="https://support.a.com/pl-pl/help/10607/a-edge-view-delete-browser-history">Edge</a></li>
                          <li><a href="https://support.a.com/pl-pl/help/278835/how-to-delete-cookie-files-in-internet-explorer">Internet Explorer</a></li>
                          <li><a href="http://support.google.com/chrome/bin/answer.py?hl=pl&amp;answer=95647">Chrome</a></li>
                          <li><a href="http://support.apple.com/kb/PH5042">Safari</a></li>
                          <li><a href="http://support.mozilla.org/pl/kb/W%C5%82%C4%85czanie%20i%20wy%C5%82%C4%85czanie%20obs%C5%82ugi%20ciasteczek">Firefox</a></li>
                          <li><a href="http://help.opera.com/Windows/12.10/pl/cookies.html">Opera</a></li>
                        </ul>
                        <p>{tr("public:legalText140")}</p>
                        <ul>
                          <li><a href="http://support.google.com/chrome/bin/answer.py?hl=pl&amp;answer=95647">Android</a></li>
                          <li><a href="http://support.apple.com/kb/HT1677?viewlocale=pl_PL">Safari (iOS)</a></li>
                          <li><a href="http://www.windowsphone.com/pl-pl/how-to/wp7/web/changing-privacy-and-other-browser-settings">Windows Phone</a></li>
                        </ul>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
              <div className="col-xl-1" />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ textAlign: "justify" }}>
          <Button onClick={this.props.onHide}>{tr("public:legalText144")}</Button>
        </Modal.Footer>
      </Modal>)}</Translation>
    );
  }
}

export default PrivacyModal;
